import React, { Component } from 'react';

import InfoWrapper from './InfoWrapper';

import AddressNotFound from './status/AddressNotFound';
import InProgress from './status/InProgress';
import NoServiceInfo from './status/NoServiceInfo';
import OnHold from './status/OnHold';
import Ready from './status/Ready';
import ThreeYearPlan from './status/ThreeYearPlan';
import AsaInfo from './status/AsaInfo';
import Remediating from './status/Remediating';


export default class InfoBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true,
      statusDetail: null
    };
    this.hide = this.hide.bind(this);
    this.showStatus = this.showStatus.bind(this);
  }

  hide() {
    this.setState({ hidden: true });
  }

  showStatus(status) {
    this.setState({ hidden: false, statusDetail: status });
  }

  renderReady(detail) {
    return (
      <InfoWrapper color="green" icon="tick" title="Ready to connect" subtitle="Compare providers and get connected">
        <Ready statusDetail={detail} />
      </InfoWrapper>
    );
  }

  renderConnected(detail) {
    return (
      <InfoWrapper color="green" icon="tick" title="Connected" subtitle="Compare providers and get connected">
        <Ready statusDetail={detail} />
      </InfoWrapper>
    );
  }

  renderInProgress(detail) {
    return (
      <InfoWrapper color="blue" icon="service" title="Construction Stage - Build commenced" subtitle="Construction on this property is under way">
        <InProgress statusDetail={ detail } />
      </InfoWrapper>
    );
  }

  renderOnHold(detail) {
    const title = 'On hold'; // TODO: Determine correct titles from API response
    const subtitle = detail.is_service_class_reason
      ? detail.service_class_reason
      : 'Further work required to connect this property';
    return (
      <InfoWrapper color="punch" icon="service" title={title} subtitle={subtitle}>
        <OnHold statusDetail={detail} />
      </InfoWrapper>
    );
  }

  renderThreeYearPlan(detail) {
    return (
      <InfoWrapper color="orange" icon="date-picker" title="Part of 3 year plan" subtitle="No specific date has been set">
        <ThreeYearPlan statusDetail={detail} />
      </InfoWrapper>
    );
  }

  renderAsaInfo(detail) {
    return (
      <InfoWrapper color="green" icon="tick" title="Adequately Served" subtitle="Contact your carrier to get connected">
        <AsaInfo statusDetail={detail} />
      </InfoWrapper>
    );
  }

  renderNoServiceInfo(detail) {
    return (
      <InfoWrapper color="crimson" icon="cross" title="No service info" subtitle="There is no data available">
        <NoServiceInfo statusDetail={detail} />
      </InfoWrapper>
    );
  }

  renderRemediating(detail) {
    return (
      <InfoWrapper color="blue" icon="service" title="In Preparation" subtitle="Pre-construction activities in this area are under way">
        <Remediating statusDetail={detail} />
      </InfoWrapper>
    );
  }

  renderAddressNotFound(detail) {
    return (
      <InfoWrapper color="nickelgrey" icon="location" title="NBN is not ready in your area" subtitle="We could not find any nbn data for your address">
        <AddressNotFound statusDetail={detail} />
      </InfoWrapper>
    );
  }

  render() {
    if (this.state.hidden || this.state.statusDetail === null) {
      return null;
    }

    const detail = this.state.statusDetail;
    const serviceClassStatus = detail.service_class_status ? detail.service_class_status.toLowerCase() : null;
    switch (serviceClassStatus) {
      case 'ready to connect':
        return this.renderReady(detail);
      case 'in progress':
        return this.renderInProgress(detail);
      case 'on hold':
        return this.renderOnHold(detail);
      case '3 year plan':
        return this.renderThreeYearPlan(detail);
      case 'connected':
        return this.renderConnected(detail);
      case 'adequately serviced area':
        return this.renderAsaInfo(detail);
      case 'remediating':
        return this.renderRemediating(detail);
      case 'no service info':
        return this.renderNoServiceInfo(detail);
    }

    if (!detail.address_matched) {
      return this.renderAddressNotFound(detail);
    }

    return null;
  }
}
